export class Bing {
  private ti: string
  private active: boolean
  private uetq?: any

  constructor(ti: string, active?: boolean) {
    this.ti = ti
    this.active = active!
  }

  public track(eventName: string, data: any) {
    return new Promise((resolve, reject) => {
      this._load()
        .then(uetq => {
          this.uetq = uetq

          this.uetq.push(data)
          resolve(data)
        })
        .catch(err => {
          console.error(err)
          reject(err)
        })
    })
  }

  public pageView(eventName: string, data: any) {
    return new Promise((resolve, reject) => {
      this._load()
        .then(uetq => {
          this.uetq = uetq

          this.uetq.push('event', 'page_view', {
            event_action: 'page_view',
            page_path: window.location.pathname,
          })
          resolve(window.location.pathname)
        })
        .catch(err => {
          reject(err)
        })
    })
  }

  private _load() {
    return new Promise((resolve, reject) => {
      const aWindow = window as any
      if (aWindow.uetq) {
        resolve(aWindow.uetq)
      } else {
        const script = document.createElement('script')

        script.textContent =
          `(function(w,d,t,r,u){var f,n,i;w[u]=w[u]||[],f=function(){var ` +
          `o={ti:"${this.ti}"};o.q=w[u],w[u]=new UET(o),w[u].push("pageLoad")},` +
          `n=d.createElement(t),` +
          `n.src=r,n.async=1,n.onload=n.onreadystatechange=function(){var s=this.readyState;s&&s!==` +
          `"loaded"&&s!=="complete"||(f(),n.onload=n.onreadystatechange=null)},i=d.` +
          `getElementsByTagName(t)[0],i.parentNode.insertBefore(n,i)})(window,document,"script",` +
          `"//bat.bing.com/bat.js","uetq");`

        document.head.appendChild(script)

        resolve(aWindow.uetq)
      }
    })
  }
}
